import { LEARNING_GET_FILE } from '.';
import Api from '../../../common/services/api';

export default (fileId) => async (dispatch) => {

  const file = await Api.get(`/v2/files/${fileId}`);

  return dispatch({
    type: LEARNING_GET_FILE,
    file,
  });
};

